// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-E":"Other_outdoor-recreation-E__XjdQx"};